Array.prototype.first = function () {
  return this[0]
}
Array.prototype.last = function () {
  return this[this.length - 1]
}
Array.prototype.sum = function <T>(by: (e: T) => number = v => v as any) {
  return this.reduce((r: number, e: T) => r + by(e), 0)
}

Array.prototype.max = function <T, R>(by: (e: T) => R = v => v as any) {
  return this.reduce((r: R, e: T) => {
    const v = by(e)
    return v > r ? v : r
  }, this.length ? by(this.first()) : undefined)
}

Array.prototype.maxBy = function <T, R>(by: (e: T) => R = v => v as any) {
  if (this.length === 0) return undefined

  const first = this.first()
  return this.reduce((res: {value: R, item: T}, item: T) => {
    const value = by(item)
    return value > res.value ? {value, item} : res
  }, {value: by(first), item: first})?.item
}

Array.prototype.min = function <T, R>(by: (e: T) => R = v => v as any) {
  return this.reduce((r: R, e: T) => {
    const v = by(e)
    return v < r ? v : r
  }, this.length ? by(this.first()) : undefined)
}

Array.prototype.indexBy = function <T, R>(by: (e: T) => string | number, combiner: (e: T, r: R) => R = (e, _) => e as any, initial?: R) {
  return this.reduce((r: any, e: T) => {
    const v = by(e)
    r[v] = combiner(e, r[v] ?? initial)
    return r
  }, {})
}

Array.prototype.groupBy = function <T>(by: (e: T) => string | number) {
  return this.indexBy(by, (e: T, r: T[]) => [...r, e], [])
}

Array.prototype.countBy = function <T>(by: (e: T) => string | number) {
  return this.indexBy(by, (_: T, r: number) => r + 1, 0)
}

Array.prototype.remove = function <T>(i: number): Array<T> {
  this.splice(i, 1)
  return this
}

Array.prototype.replaceById = function <T extends {id: string}>(e: T) {
  this[this.findIndex((a: T) => a.id == e.id)] = e
  return this
}

Array.prototype.sortBy = function <T>(by: (e: T) => any) {
  return this.toSorted((e1, e2) => {
    const e1Value = by(e1)
    const e2Value = by(e2)

    if (e1Value instanceof Array) {
      return e1Value.reduce((res, _, i) => {
        if (e1Value[i] == null && e2Value[i] == null) return res || 0
        if (e1Value[i] == null) return res || 1
        if (e2Value[i] == null) return res || -1
        return res || (e1Value[i] > e2Value[i] ? 1 : -1)
      }, 0)
    } else {
      if (e1Value === undefined || e1Value === null) return 1
      if (e2Value === undefined || e2Value === null) return -1
      
      return e1Value > e2Value ? 1 : -1
    }
  })
}

export {}
